import api from './axios';

export interface OnlineStats {
  online: number;
  authenticated: number;
  guests: number;
}

export const pingPresence = (visitorId: string) =>
  api.post('/api/presence/ping', { visitorId });

export const fetchOnlineStats = () =>
  api.get<OnlineStats>('/api/admin/presence').then(response => response.data);
